import React from 'react';
import { TagColored } from '@spark';
import { getSparkTagVariant } from '@/features/datasets/components/DataSelection/sparkLabelColors';

/**
 * Read-only preview of a cross-referenced classification `labels` column
 * (single- or multi-label). Renders each label as a Spark TagColored pill
 * instead of the raw stringified array, matching the primary Labels column look.
 */
export const LabelsPreviewCell = ({ labels = [], allLabels = [] }) => {
    const hasLabels = Array.isArray(labels) && labels.length > 0;

    return (
        // Full-height centered wrapper so tags align vertically with the
        // primary Labels column selector in the same row.
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', alignContent: 'center', gap: '4px', height: '100%' }}>
            {hasLabels ? (
                labels.map((label, index) => (
                    <TagColored
                        key={`${label}-${index}`}
                        label={label}
                        variant={getSparkTagVariant(label, allLabels)}
                    />
                ))
            ) : (
                <span>No labels</span>
            )}
        </div>
    );
};

export default LabelsPreviewCell;
